export default __webpack_public_path__ + "static/media/TelegramIcon.9b43b1c6.svg";